





















import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { User, SocketState, World } from '@/types';

@Component
export default class Travel extends Vue {
  @State public user!: User;
  @State public socket!: SocketState;
  @State public world!: World;

  public updated() {
    if (this.user.socketLock) {
      this.$router.push('/world/travel');
    }
  }
  get bgColor() {
    // number from 0-23 relating to the hour of the day in the world
    const worldHour = new Date(this.world.timeOfDay).getHours();
    if (worldHour >= 5 && worldHour < 9) {
      // morning
      return 'linear-gradient(#89b8ff, #fdaea3)';
    } else if (worldHour >= 9 && worldHour < 19) {
      // day
      return 'linear-gradient(#1c6fcf, #95d6f8)';
    } else if (worldHour >= 19 && worldHour < 21) {
      // evening
      return 'linear-gradient(#52adff, #ed8d45)';
    } else {
      // night
      return 'linear-gradient(#01071f, #663c94)'
    }
  }
}
